import WithGASetup from '../../components/WithGASetup';
import LoginPage from './LoginPage.js';

export default WithGASetup(LoginPage);
